import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';
export const HelpMeChooseResultSkeleton: React.FC = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="heading-sm heading-neutral-amplified"><Skeleton height="1.5rem" width="25%" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-comfy-lg">{t0}<div className="label-moderate label-lg mt-snug-lg"><Skeleton height="1rem" width="80%" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="sm:hidden"><div><Skeleton height="1.5rem" width="55%" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="ChildBio__media flex-1 align-start">{t2}<div className="pb-roomy-sm"><Skeleton width="100%" height="auto" style={{
          aspectRatio: "3/4"
        }} borderRadius="0.5rem" /></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="hidden sm:block mb-comfy-lg"><Skeleton height="4rem" width="55%" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mb-0 sm:pb-comfy-sm text-sm order-1 "><Skeleton height="1rem" width="88%" /><Skeleton height="1rem" width="92%" /><Skeleton height="1rem" width="95%" /><Skeleton height="1rem" width="90%" /><Skeleton height="1rem" width="85%" /><Skeleton height="1rem" width="30%" /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="order-2 sm:order-last"><Skeleton height="2em" width="40%" /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mb-comfy-xl">{t1}<div><div className="ChildBio ChildBio__flex flex flex-col"><div className="ChildBio__content flex flex-col sm:flex-row gap-comfy-sm sm:gap-comfy-xl">{t3}<div className="ChildBio__summary flex flex-col flex-1 gap-comfy-sm sm:gap-0 sm:pt-0">{t4}{t5}{t6}<div className="order-3"><p><Skeleton height="1.5rem" width="60%" /></p><p><Skeleton height="1.5rem" width="60%" /></p><p><Skeleton height="1.5rem" width="60%" /></p><p><Skeleton height="1.5rem" width="60%" /></p><p><Skeleton height="1.5rem" width="60%" /></p></div></div></div></div></div></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};